import React from "react"
//import { StaticImage } from 'gatsby-plugin-image'
import { graphql } from "gatsby"

import * as styles from "../../styles/page/second.module.scss"
//import * as dashboardStyles from "../../styles/page/dashboard.module.scss"

// 共通コンポーネント
import Meta from "../../components/layouts/meta"
import Layout from "../../components/layouts/default"
import BreadCrumb from "../../components/layouts/bread-crumb"
import Modal from "react-modal"

// Chartコンポーネント
import SearchFilter from "../../components/parts/chart/search-filter"
import SankyModal from "../../components/parts/modal"


// markup
class IndexPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false
    }

    this.searchInit = {
      filter1Init: 0,
      filter2Init: 0,
      filter3Init: 'market-trend'
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal(e) {
    this.setState({modalOpen : true})
  }
  closeModal(e) {
    this.setState({modalOpen : false})
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  render() {
    const markdownRemark = this.props.data.markdownRemark
    const { frontmatter } = markdownRemark
    const { title, description, slug } = frontmatter

    return (
      <Layout>
        <Meta 
          title={title}
          description={description}
          path={slug}
        />

        <BreadCrumb
          currentTitle={title}
        />

        <div className={styles.pageTitle}>
          <h1 className={styles.pageTitleHeading}>{title}</h1>
        </div>

        <SearchFilter {...this.searchInit} />
        
        <main className={styles.pageContents}>
          <h2 className={styles.pageContentsHeading2}>About this dashboard</h2>
          <p className="pb-3 leading-7">This is a website which organized useful information of industries and technologies related to Green Innovation Fund Projects in a easy-to-understand way. Data stated in this website was compiled based on the data which NEDO went public. For description of each data, please refer to each source of the data. Unless otherwise there is no specific statement, the chart which is stated to be "Drawn up" in each source is what the NEDO drew up those charts based on the source's information.</p>

          <h3 className={styles.pageContentsHeading3}>How to use this dashboard</h3>
          <ul>
            <li>When you select "focusing area," "each area," or "classification," and then click "display" button, a chart corresponding classification will be displayed.</li>
            <li>There are some charts which you can change data to be displayed by pulling down menus. Also, you can download some of the data.</li>
          </ul>

          <h3 className={styles.pageContentsHeading3}>Outlook for future scenario by International Energy Agency(IEA)</h3>
          <ul>
            <li>NZE (Net Zero Emission) : Scenario for the global energy sector to achieve net zero CO<sub>2</sub> emissions by 2050</li>
            <li>SDS (Sustainable Development Scenario) : Scenario to achieve key energy-related United Nations Sustainable Development Goals</li>
            <li>APS (Announced  Pledge Scenario) : Scenario which assumes that all climate commitments made by governments around the world will be met in full and on time</li>
            <li>STEPS (Stated Policy Scenario) : Scenario which reflects current policies that are in place, as well as those that have been announced by governments around the world</li>
          </ul>

          <h3 className={styles.pageContentsHeading3}>Summary: Energy balance flow of IEA NZE (2050）</h3>
          <div className="pb-5">
            <div>
              <button className={styles.modalLink} onClick={this.openModal}>
                <img src={`${process.env.S3_PREFIX}/images/chart/sanky-1.svg`} alt="Summary: Energy balance flow of IEA NZE2050）" width="100%" height="auto" />
              </button>
              <SankyModal
                open={this.state.modalOpen}
                close={this.closeModal}
                src={`${process.env.S3_PREFIX}/images/chart/sanky-1.svg`}
                alt={"Summary: Energy balance flow of IEA NZE2050）"}
                style={{width : '100%', height: 'auto'}}
              />
            </div>
          </div>
          <ul>
            <li>According to IEA and NZE, ratio of electricity (the ratio of electricity  of final consumption energy ) will reach 49 % in 2050,  which is approximately 2.5 times larger than that of 2020. For power generation division, the ratio of renewable energy will increase to 88 % by 2050, which will lead to minus CO<sub>2</sub> emissions in conjunction with utilization of biomass  and CCS etc.</li>
            <li>In 2050, outputs of hydrogen will reach 528 million tons, which account for 60 % or more water electrolyte and slightly fewer than 40 % of fossil fuel plus CCS. Hydrogen base fuel is utilized by all divisions, mainly transportation, industry and power generation divisions, which greatly contributes to achievement of carbon neutrality.</li>
            <li>In 2050, CO<sub>2</sub> capture will reach 7.6 billion tons, within which 6.6 billion tons of CO<sub>2</sub> comes from fixed emissions source and 1 billion tons of CO<sub>2</sub> comes from direct air capture with carbon storage(DACCS).</li>
          </ul>
          <p className="pb-3 leading-7">Source: <a href="https://www.iea.org/reports/net-zero-by-2050" className={styles.linkText} target="_blank" rel="noreferrer noopener">Drawn up on the basis of IEA, ”Net Zero by 2050”</a> (May, 2021)<br />
          This indicates energy flow from global primary energy supply  to final consumption under the IEA  net zero scenario in 2050. The differences between each item of input and output are tabulated as losses and those data might not match the total due to the limit of information stated in the sources.</p>
        </main>
      </Layout>
    )
  }
}
export default IndexPage

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: {slug: {eq: $slug}}) {
      html
      frontmatter {
        title
        description
        slug
      }
    }
  }
`